import { getResolvedTenantCode } from 'config/resolvedTenant';

export const scopeStorageKey = (baseKey: string): string => {
  const tenantCode = getResolvedTenantCode();
  return tenantCode ? `${baseKey}__${tenantCode}` : baseKey;
};

export const tenantStorage = {
  getItem: (baseKey: string): string | null => localStorage.getItem(scopeStorageKey(baseKey)),
  setItem: (baseKey: string, value: string): void => localStorage.setItem(scopeStorageKey(baseKey), value),
  removeItem: (baseKey: string): void => localStorage.removeItem(scopeStorageKey(baseKey)),
};
